import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import CategoryEventCards from '../layoutComponents/CategoryEventCards';


@observer(["TeamStore", "ViewStore"])

class EventCategories extends Component {
    constructor(props) {
        super(props);

        this.state = {


        };
        this.props.TeamStore.queryTeams();
    }
    componentWillMount() {
        this.props.ViewStore.changeCurrentPage('Categories');
    }

    componentWillUnmount() {
        this.props.ViewStore.changePreviousPage('Categories');
        this.props.TeamStore.queryTeams();

    }

    render() {

        const { store } = this.props;
        const { router: { params } } = store;


        let category = <div><CategoryEventCards categoryId={params.categoryId} /></div>


        return (
            <div>
                <div style={{ marginTop: '25px' }}>
                    {category}
                </div>
            </div>
        );
    }
}

export default inject('store')(observer(EventCategories));


// WEBPACK FOOTER //
// ./src/components/appComponents/EventCategories.js